import React from 'react';
import './Card.css';

const Card = ({
                  children,
                  title,
                  className = '',
                  onClick,
                  variant = 'default'
              }) => {
    return (
        <div
            className={`card card-${variant} ${className} ${onClick ? 'clickable' : ''}`}
            onClick={onClick}
        >
            {title && <h3 className="card-title">{title}</h3>}
            <div className="card-content">
                {children}
            </div>
        </div>
    );
};

export default Card;